import React from "react";

export default function DriversRatingTable({ data = [] }) {
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        padding: 16,
        boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
      }}
    >
      <h3 style={{ marginTop: 0 }}>Рейтинг водителей</h3>
      <p style={{ color: "#666", marginBottom: 10 }}>
        По количеству выполненных заказов.
      </p>

      {data.length === 0 ? (
        <p style={{ color: "#999" }}>Нет данных за выбранный период.</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                {["Водитель", "Всего", "Доставлено", "% выполнено"].map((h) => (
                  <th
                    key={h}
                    style={{
                      textAlign: "left",
                      padding: "8px 6px",
                      borderBottom: "1px solid #eee",
                      fontWeight: 600,
                      fontSize: 14,
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((d) => (
                <tr key={d.driver}>
                  <td style={cell}>{d.driver}</td>
                  <td style={cell}>{d.total}</td>
                  <td style={cell}>{d.done}</td>
                  <td style={cell}>{d.percent}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const cell = {
  padding: "8px 6px",
  borderBottom: "1px solid #f5f5f5",
  fontSize: 14,
};
